// extracted by mini-css-extract-plugin
export default {"gridCard":"ContasLayout_gridCard__P3zBV","cards":"ContasLayout_cards__PHyRg","filGrid":"ContasLayout_filGrid__axIcu"};